import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { LanguagesEnum } from './enum';
import packageJson from '../../package.json';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: [LanguagesEnum.EN, LanguagesEnum.IT],
    lng: LanguagesEnum.EN,
    fallbackLng: LanguagesEnum.EN,

    react: { useSuspense: false },
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['path', 'cookie', 'htmlTag'],
      caches: ['cookie'],
    },
    backend: {
      loadPath: `/locales/{{lng}}/translation.json?v=${packageJson.version}`,
    },
  });

export default i18n;
